export const EXCMTEAM_CREATE_RESET = 'EXCMTEAM_CREATE_RESET'
export const EXCMTEAM_CREATE_SET_CREATED = 'EXCMTEAM_CREATE_SET_CREATED'
export const EXCMTEAM_CREATE_SET_ERROR = 'EXCMTEAM_CREATE_SET_ERROR'
export const EXCMTEAM_CREATE_SET_VIOLATIONS = 'EXCMTEAM_CREATE_SET_VIOLATIONS'
export const EXCMTEAM_CREATE_TOGGLE_LOADING = 'EXCMTEAM_CREATE_TOGGLE_LOADING'
